import React from "react";

/**
 * AdminBadge — inline red admin indicator used on LIVE streams so every
 * viewer can tell when the Bidorah admin is in the room or typing.
 *
 * Renders: small gold shield icon (transparent PNG at /admin-badge.png) and
 * a red "ADMIN" pill. Designed to sit next to the admin's user name in chat
 * and presence feeds.
 */

export default function AdminBadge({ size = 16, showLabel = true, pulse = false, className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-1 align-middle ${
        pulse ? "admin-entry-pulse" : ""
      } ${className}`}
      data-testid="admin-badge"
    >
      {showLabel && (
        <span
          className="text-[9px] font-mono tracking-widest font-bold uppercase px-1.5 py-0.5 rounded-full bg-[#EF4444] text-white shadow-sm"
          style={{ letterSpacing: "0.14em" }}
        >
          Admin
        </span>
      )}
      <img
        src="/admin-badge.png"
        alt="Admin"
        draggable={false}
        style={{
          height: size,
          width: "auto",
          filter: "drop-shadow(0 1px 2px rgba(0,0,0,0.5))",
        }}
        className="select-none"
      />
    </span>
  );
}
